import { render, staticRenderFns } from "./CreateTraining.vue?vue&type=template&id=bc10e2c0"
import script from "./CreateTraining.vue?vue&type=script&lang=js"
export * from "./CreateTraining.vue?vue&type=script&lang=js"
import style0 from "./CreateTraining.vue?vue&type=style&index=0&id=bc10e2c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports